import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, signal } from "@angular/core";
import { FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { ActivatedRoute, Router } from "@angular/router";
import { TypedDialog } from "@tenzu/utils/services/typed-dialog-service/typed-dialog.service";
import { injectPortailService } from "./portal.service";
import { TranslocoDirective } from "@jsverse/transloco";
import { PortalSuccessComponent } from "./portal-success/portal-success.component";
import { PortalLeftPanelComponent } from "./portal-left-panel/portal-left-panel.component";
import { PortalFormComponent } from "./portal-form/portal-form.component";
import { MatDialogClose } from "@angular/material/dialog";

@Component({
  selector: "app-tenzu-front-portal",
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TranslocoDirective,
    PortalSuccessComponent,
    PortalLeftPanelComponent,
    PortalFormComponent,
    MatDialogClose,
  ],
  template: `
    <ng-container *transloco="let t">
      @switch (success()) {
        @case (true) {
          <app-tenzu-front-portal-success></app-tenzu-front-portal-success>
        }
        @case (false) {
          <div class="grid grid-cols-2 gap-4">
            <div class="col-span-1 flex flex-col items-center justify-center gap-4 p-8">
              @if (expanded()) {
                <div
                  class="col-span-1 flex flex-col items-center justify-center gap-4 p-8"
                  [innerHTML]="t('portal.modal.left_panel.expanded_text')"
                ></div>
              } @else {
                <app-tenzu-front-portal-left-panel [priceAmount]="priceAmount()"></app-tenzu-front-portal-left-panel>
              }
            </div>
            <app-tenzu-front-portal-form
              class="col-span-1 flex flex-col items-center justify-center gap-4 p-8"
              [customerInfo]="customerInfo()"
              (priceAmount)="priceAmount.set($event)"
              (ignoreModal)="ignoreModal()"
              (goToCustomerPortal)="goToCustomerPortal()"
              (submitForm)="submit($event)"
            ></app-tenzu-front-portal-form>
          </div>

          <div class="flex justify-center">
            @if (expanded()) {
              <button mat-dialog-close (click)="ignoreModal()" class="text-tertiary underline mb-2">
                {{ t("portal.modal.cancel") }}
              </button>
            } @else {
              <button (click)="expanded.set(true)" class="text-tertiary underline mb-2">
                {{ t("portal.modal.expand") }}
              </button>
            }
          </div>
        }
      }
    </ng-container>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class PortalComponent extends TypedDialog<{ success: boolean }, unknown> {
  route = inject(ActivatedRoute);
  router = inject(Router);
  fb = inject(NonNullableFormBuilder);
  portalService = injectPortailService();
  customerInfo = this.portalService.customerInfo;
  priceAmount = signal<number | undefined>(undefined);
  success = signal(false);
  expand = input(false);
  protected expanded = linkedSignal(() => this.expand());

  constructor() {
    super();
    this.success.set(this.data.success);
    const success = this.route.snapshot.queryParamMap.get("success");
    if (success && success.toLowerCase() === "true") {
      this.success.set(true);
    }
  }

  goToCustomerPortal() {
    this.portalService.goToCustomerPortal(this.router.url);
  }

  submit(data: { priceAmount: number; recurrent: boolean }) {
    this.portalService.submit(data);
  }

  ignoreModal() {
    this.portalService.ignoreModal();
  }
}
